import { render, staticRenderFns } from "./CowVaccination.vue?vue&type=template&id=18540832&scoped=true&"
import script from "./CowVaccination.vue?vue&type=script&lang=js&"
export * from "./CowVaccination.vue?vue&type=script&lang=js&"
import style0 from "./CowVaccination.vue?vue&type=style&index=0&id=18540832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18540832",
  null
  
)

export default component.exports